import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[qtHeaderDef]',
  standalone: false,
})
export class HeaderDefDirective {
  @Input('qtHeaderDef') id: string;

  template = this.templateRef;
  constructor(private templateRef: TemplateRef<any>) {}
}
